<template>
  <div>
    <b-dropdown
      id="settingsMenu"
      ref="settingsMenu"
      no-caret
      right
    >
      <template #button-content>
        <span class="sr-only">
          Settings Menu
        </span>
        <slot name="button-content">
          <GearSVG />
        </slot>
      </template>
      <slot name="menu-content">
        <b-dropdown-item
          to="/settings/account"
          @click.native="trackMenuItemSelected('Settings')"
        >
          Settings
        </b-dropdown-item>
        <b-dropdown-item
          to="/logout"
          @click.native="handleLogout"
        >
          Logout
        </b-dropdown-item>
      </slot>
    </b-dropdown>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue';
import GearSVG from '@/assets/svg/gear.svg';
import Analytics from '@/mixins/Analytics';

export default {
  name: 'AcvSettingsDropdownMenu',
  components: {
    BDropdown,
    BDropdownItem,
    GearSVG,
  },
  mixins: [
    Analytics,
  ],
  props: {
    hasOutstandingAuctions: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    show() {
      this.$refs.settingsMenu.show();
    },
    hide() {
      this.$refs.settingsMenu.hide();
    },
    handleLogout() {
      // clear stored route
      this.$store.dispatch('clearGoToAfterLogin');
      this.trackMenuItemSelected('Logout');
    },
    trackMenuItemSelected(item) {
      this.track(this.eventNames.userMenuSelected, {
        item_selected: item,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep #settingsMenu {
  &.btn-group {
    top: -1px;
  }

  .btn.btn-secondary {
    border: 0;
    background: none;
  }

  .btn {
    line-height: 1;

    &:hover {
      background: constants.$darker-gray;
      border: 0;

      svg {
        color: rgb(255 255 255 / 100%);
      }
    }

    &:focus,
    &:active {
      outline: 0;
      border: 0;
      box-shadow: none;
    }
  }

  .dropdown-menu {
    padding: 0;
    margin: 20px 0 0;
    border: 0;
    border-radius: 2px;
    min-width: auto;
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 23%);
  }

  .dropdown-item {
    padding: 14px 15px;
    text-align: right;
    font-size: 14px;
    line-height: 1rem;
    margin-right: 30px;
    outline: none;
    border-bottom: solid 1px rgb(50 50 50 / 10%);
    font-weight: 500;
    letter-spacing: 1.25px;
    color: rgb(0 0 0 / 50%);

    a {
      color: #333;
    }

    &:hover {
      background: #f3f3f3;
    }

    &:last-of-type {
      border: none;
    }
  }

  svg {
    color: rgb(255 255 255 / 80%);
    font-size: 21.44px;

    &:hover {
      i,
      svg {
        color: rgb(255 255 255 / 100%);
      }
    }
  }
}
</style>
